import Swal from 'sweetalert2';

export class AlertHelper {
  static success(message: string, title: string = 'Success') {
    Swal.fire({
      icon: 'success',
      title,
      text: message,
      timer: 2000,
      showConfirmButton: false
    });
  }

  static error(message: string, title: string = 'Error') {
    Swal.fire({
      icon: 'error',
      title,
      text: message,
      timer: 2500,
      showConfirmButton: true
    });
  }
}